import React from 'react';
import FormGroup from './FormGroup';
import './Input.css';

const Input = ({
  label,
  helpText,
  error,
  required,
  optional,
  className = '',
  ...props
}) => {
  return (
    <FormGroup label={label} helpText={helpText} error={error} required={required} optional={optional}>
      <input
        className={`p-input ${className}`}
        required={required}
        {...props}
      />
    </FormGroup>
  );
};

export default Input;
